<script>
  export default {
    name: 'vqTabs',
    data() {
      return {
        tabIndex: 1,
      };
    },
    methods: {
      setIndex(index) {
        this.tabIndex = index
      },
    },
    render(h) {
      return this.$scopedSlots.default({
        setIndex: this.setIndex,
        tabIndex: this.tabIndex
      });
    },
  };  
</script>
<style>
.list-complete-enter, .list-complete-leave-to {
  opacity: 0;
  transform: translateY(60px);
}
.list-complete-leave-active {
  @apply tw-absolute;
}

.list-complete-item {
  transition: all .5s;
}
</style>